export default __webpack_public_path__ + "static/media/facebook.a445a02e.svg";